import { Alert } from '@mui/material';

import AssessmentReportItem, { AssessmentReportItemLoading } from '@StandingAccess/components/AssessmentReportItem';

import AssessmentReportReassess from './AssessmentReportReassess';
import useGetReport from '@StandingAccess/hooks/use-get-report';

interface AssessmentReportHeaderItemProps {
  reportId: string;
}

export default function AssessmentReportHeaderItem({ reportId }: AssessmentReportHeaderItemProps) {
  const { report, isFetched } = useGetReport(reportId);

  if (!isFetched) return <AssessmentReportItemLoading />;

  if (!report)
    return (
      <Alert severity="error" variant="outlined">
        Report not found
      </Alert>
    );

  return (
    <AssessmentReportItem key={report.report.id} report={report.report} integration={report.integration} small>
      <AssessmentReportReassess report={report.report} />
    </AssessmentReportItem>
  );
}
